"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _flex = _interopRequireDefault(require("../../../../styles-common/flex"));

var _inputGroup = _interopRequireDefault(require("../../../../styles-common/input-group"));

var _formLabel = _interopRequireDefault(require("../../../../styles-common/form-label"));

var _queryLimit = _interopRequireDefault(require("../../../query-limit"));

var _FilterValue = _interopRequireDefault(require("../FilterValue"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var DateRangeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "component__DateRangeWrapper",
  componentId: "d8385z-0"
})(["margin-top:15px;"]);

var FilterRange = function FilterRange(_ref) {
  var filter = _ref.filter,
      _onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["filter", "onChange"]);

  var _filter$config = filter.config,
      min = _filter$config.min,
      max = _filter$config.max;

  var _ref2 = Array.isArray(filter.value) ? filter.value : [filter.type === 'number' ? Math.floor(min) : new Date(min).toISOString().split('T')[0], filter.type === 'number' ? Math.ceil(max) : new Date(max).toISOString().split('T')[0]],
      _ref3 = _slicedToArray(_ref2, 2),
      minValue = _ref3[0],
      maxValue = _ref3[1];

  if (filter.type === 'date') {
    return _react["default"].createElement(DateRangeWrapper, null, _react["default"].createElement(_flex["default"], {
      row: true
    }, _react["default"].createElement(_inputGroup["default"], {
      noMargins: true
    }, _react["default"].createElement(_formLabel["default"], {
      htmlFor: "filter-range-".concat(filter.id, "-from")
    }, "From"), _react["default"].createElement(_FilterValue["default"], {
      id: "filter-range-".concat(filter.id, "-from"),
      filter: _objectSpread({}, filter, {
        value: minValue,
        config: _objectSpread({}, filter.config, {
          max: +new Date(maxValue)
        })
      }),
      onChange: function onChange(value) {
        return _onChange([new Date(value), new Date(maxValue)]);
      }
    })), _react["default"].createElement(_inputGroup["default"], {
      noMargins: true
    }, _react["default"].createElement(_formLabel["default"], {
      htmlFor: "filter-range-".concat(filter.id, "-to")
    }, "To"), _react["default"].createElement(_FilterValue["default"], {
      id: "filter-range-".concat(filter.id, "-to"),
      filter: _objectSpread({}, filter, {
        value: maxValue,
        config: _objectSpread({}, filter.config, {
          min: +new Date(minValue)
        })
      }),
      onChange: function onChange(value) {
        return _onChange([new Date(minValue), new Date(value)]);
      }
    }))));
  }

  return _react["default"].createElement(_queryLimit["default"], _extends({
    isFilter: true,
    min: Math.floor(min),
    max: Math.ceil(max),
    value: [minValue, maxValue],
    onChange: _onChange
  }, rest));
};

FilterRange.propTypes = {
  filter: _propTypes["default"].shape({
    column: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired,
    operation: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].any, _propTypes["default"].arrayOf(_propTypes["default"].any)]),
    config: _propTypes["default"].object.isRequired
  }).isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = FilterRange;
exports["default"] = _default;